<template>
    <div>
        <form @submit.prevent="getContent" role="search" class="relative max-w-2xl pt-4 md:pt-6">
            <span class="icon-search pointer-events-none absolute left-5 top-[calc(50%+0.5rem)] -translate-y-1/2 text-lg text-nomad-400 md:top-[calc(50%+0.75rem)]" aria-hidden="true"></span>
            <input type="search" v-model="q" placeholder="What do you want to listen to?"
                aria-label="Search songs, artists, albums or podcasts"
                class="h-12 w-full rounded-full border-0 bg-white/[0.07] pl-12 pr-5 text-base text-white placeholder:text-nomad-400 focus:bg-white/[0.1] focus:outline-none focus:ring-2 focus:ring-white/20 md:h-14"
                :disabled="laoding" autofocus />
        </form>

        <section v-if="!q && homepage.playlists && homepage.playlists.length" class="mt-10">
            <h2 class="nl-section-title mb-2 px-0.5">Browse playlists</h2>
            <div class="-mx-2.5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                <MediaCard v-for="playlist in homepage.playlists" :key="playlist.id" :href="'/playlist/' + playlist.id"
                    :image="playlist.cover" :title="playlist.name" :subtitle="playlist.songs_count + ' songs'" />
            </div>
        </section>

        <div v-if="laoding" class="mt-10 space-y-2">
            <div v-for="i in 6" :key="i" class="h-12 animate-pulse rounded-md bg-white/[0.03]"></div>
        </div>
        <div v-else>
            <p v-if="message" class="mt-10 text-nomad-400">{{ message }}</p>

            <section v-if="songs.length" class="mt-10">
                <h2 class="nl-section-title mb-3 px-0.5">Songs</h2>
                <TrackList :songs="songs" />
            </section>

            <AdSlot v-if="songs.length" placement="listFeed" class="mt-10" />

            <Shelf title="Artists" :items="artists">
                <template #default="{ item }">
                    <MediaCard :href="'/artist/' + item.id" :image="item.image" :title="item.name" subtitle="Artist" round />
                </template>
            </Shelf>

            <Shelf title="Albums" :items="albums">
                <template #default="{ item }">
                    <MediaCard :href="'/album/' + item.id" :image="item.cover" :title="item.name" :subtitle="item.released_at" />
                </template>
            </Shelf>

            <Shelf title="Podcasts" :items="podcasts || []">
                <template #default="{ item }">
                    <MediaCard :href="'/podcast/' + item.id" :image="item.image" :title="item.title" :subtitle="item.host" />
                </template>
            </Shelf>

            <div class="mt-10 flex items-center justify-between gap-3" v-if="pagination && pagination.last_page > 1">
                <button class="nl-btn-ghost" v-if="pagination.current_page > 1" @click="prevPage">
                    <span class="icon-chevron-left"></span> Previous
                </button>
                <span v-else></span>
                <button class="nl-btn-ghost" v-if="pagination.current_page < pagination.last_page" @click="nextPage">
                    Next <span class="icon-chevron-right"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup></script>

<script>
import AdSlot from "@/components/ui/AdSlot.vue";
import CardArtist from "@/components/CardArtist.vue";
import { defineAsyncComponent } from 'vue'
import {
    ArtistPlaceholder,
    GridArtistsPlaceholder,
} from "@/components/placeholders/placeholder.js";
import CardSong from "@/components/CardSong.vue";
import AlbumCard from "@/components/AlbumCard.vue";
import { router } from "@inertiajs/vue3";
import axios from "axios";
import { mapState, mapActions, } from "vuex";
import PopularGenres from "@/components/PopularGenres.vue";
import MediaCard from "@/components/ui/MediaCard.vue";
import Shelf from "@/components/ui/Shelf.vue";
import TrackList from "@/components/ui/TrackList.vue";

export default {
    inject: ["current"],

    provide() {
        return {
            stream: this.$root.$data,
        };
    },
    data() {
        return {
            q: null,
            laoding: false,
            albums: [],
            songs: [],
            artists: [],
            podcasts: [],
            contents: [],
            message: null,
            pagination: null,
            page: 0,
        };
    },
    created() {
        this.prepareHomepage();
    },
    beforeMount() {
        document.title = "Search for Somali Music & Lyrics"
    },
    methods: {
        ...mapActions("homepage", ["prepareHomepage"]),
        scrollToTop() {
            document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
        },
        nextPage() {
            if (this.pagination && this.pagination.current_page < this.pagination.last_page) {
                this.page = ++this.pagination.current_page
                this.scrollToTop()
                this.getContent()
            }
        },
        prevPage() {
            if (this.pagination && this.pagination.current_page > 1) {
                this.page = --this.pagination.current_page
                this.scrollToTop()
                this.getContent()
            }
        },
        getContent() {
            this.laoding = true;
            this.message = null;
            axios
                .get("/api/searchy", { params: { query: this.q, page: this.page } })
                .then((response) => {
                    this.pagination = response.data.pagination;
                    this.albums = response.data.albums;
                    this.songs = response.data.songs;
                    this.artists = response.data.artists;
                    this.podcasts = response.data.podcasts;
                    this.message = response.data.message ?? null
                    this.laoding = false;
                }).catch((error) => { });
        },
    },
    computed: {
        ...mapState({
            homepage: (state) => state.homepage.all,
        }),
    },
    components: {
        AdSlot,
        MediaCard, Shelf, TrackList,
        "card-artist": CardArtist,
        "card-song": CardSong,
        "grid-artists-placeholder": GridArtistsPlaceholder,
        "popular-genres": PopularGenres,
        AlbumCard,
        'podcast-card': defineAsyncComponent(() => import('@/components/PodcastCard.vue'))
    }
};
</script>
